import React from 'react';
import styled from '@emotion/styled';

const Wrap = styled.div`
  padding: 16px;
`;
const Title = styled.div`
  position: relative;
  font-size: 16px;
  font-weight: 600;
  padding-left: 20px;

  &::before {
    position: absolute;
    content: ' ';
    width: 4px;
    height: 14px;
    background-color: var(--ant-primary-color);
    top: 50%;
    bottom: 0;
    left: 8px;
    transform: translateY(-50%);
  }
`;

export interface FormWrapProps {
  title?: string;
  children: React.ReactNode;
}

const FormWrap = (props: FormWrapProps) => {
  const { title, children } = props;

  return (
    <>
      {title ? <Title>{title}</Title> : null}
      <Wrap>{children}</Wrap>
    </>
  );
};

export default FormWrap;
